import { API_URL } from 'api/constants';

export const UPDATE_SETTING = `${API_URL}/v1/settings/update_settings`;

export const GET_SETTING = `${API_URL}/v1/settings`;
